// import {takeLatest, put, call, delay} from 'redux-saga/effects';
import {createSmartAction, createReducer} from 'redux-smart-actions';

export const deleteToken = createSmartAction();
export const setToken = createSmartAction(token => ({token}));

export const postAuth = createSmartAction(data => ({
  request: {
    url: 'jwt-auth/v1/token',
    method: 'post',
    data,
  },
  meta: {
    onSuccess: (response, requestAction, {dispatch}) => {
      if (response.data?.token) {
        dispatch(setToken(response.data?.token));
      }
      return response;
    },
  },
}));

export const reducer = createReducer(
  {
    [setToken.toString()]: (s, {token}) => token,
    [deleteToken.toString()]: () => null,
  },
  null,
);

export const getToken = ({token}) => token;

export function* saga() {
  // debug //
  // yield delay(400);
  // yield put(deleteToken());
  // yield put(setToken('123'));
  // yield put(postAuth({login: 'test', password: 'test'}));
}
